import React from 'react';
import './css/Blog.css';

const LifouraBlog = () => {
  return (
    <div>
      {/* <!-- Basic Meta --> */}
<title>Lifoura – Preserve Your Life Story Forever</title>
<meta name="description" content="Lifoura helps you preserve life’s most precious moments—photos, videos, and journal entries—in a private, encrypted memory timeline. Start your digital legacy today." />
<meta name="keywords" content="digital memory, life story preservation, AI-powered photo storage, emotional storytelling platform, encrypted memory storage, secure family timeline, baby milestones, legacy builder, memory journal app, preserve family memories" />
<meta name="author" content="Lifoura Team" />
<meta name="viewport" content="width=device-width, initial-scale=1" />

{/* <!-- Open Graph / Facebook --> */}
<meta property="og:type" content="website" />
<meta property="og:url" content="https://www.lifoura.com/" />
<meta property="og:title" content="Preserve Your Life Story | Lifoura" />
<meta property="og:description" content="Create your private, encrypted memory vault with Lifoura. Organize and share photos, videos, and stories in a beautiful timeline." />
<meta property="og:image" content="https://yourdomain.com/assets/preview-lifoura.jpg" />

{/* <!-- Twitter --> */}
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:title" content="Preserve Your Life Story | Lifoura" />
<meta name="twitter:description" content="Lifoura helps you build a digital legacy through AI-organized memories, emotional storytelling, and secure sharing with loved ones." />
<meta name="twitter:image" content="https://yourdomain.com/assets/preview-lifoura.jpg" />


    <div className="lifoura-container">
     <header className="lifoura-hero">
  <div className="lifoura-logo-container">
    <img
      src="/assets/lifoura-04.png"
      alt="Lifoura Logo"
      className="lifoura-logo"
    />
  </div>

  <div className="lifoura-hero-text">
    <h1>Preserve Your Life Story</h1>
    <p>One timeline. One memory vault. Yours forever.</p>
  </div>
</header>


      <section className="lifoura-section">
        <h2>Memories Deserve Better</h2>
        <div className="lifoura-section-content">
          <img src="https://i.pinimg.com/736x/8e/26/57/8e26575388fe4a49ff795efda448e838.jpg" alt="digital memory"  style={{ width: '250px', height: '290px' }} />
          <p>
             <strong>Lifoura is simple:</strong> Digital memory are scattered—phones, drives, cloud accounts. Lifoura brings them all
            together in one private, encrypted timeline.<br></br> No clutter. No lost folders. Just your story—<strong>visually rich</strong>, <strong>emotionally vivid</strong>, and 
      <strong> beautifully preserved</strong>. Whether you're starting fresh or importing decades of memories, 
      Lifoura makes the process effortless and deeply meaningful.
          </p>
        </div>
      </section>

      <section className="lifoura-section">
        <h2>Capture Every Emotion</h2>
        <div className="lifoura-section-content">
          <p>
            Every smile, tear, and milestone matters. With Lifoura, you're not just storing media;
            you're preserving emotion, growth, and legacy.<br></br>Capture your baby’s first laugh, record bedtime stories with your parents, or save heartfelt letters
      you’ve written but never sent. Lifoura transforms fleeting moments into lasting digital memories. Each memory is elegantly time-stamped, beautifully presented, and securely stored—ready to be
      revisited anytime you need a dose of nostalgia or love.
          </p>
          
          <img src="https://i.pinimg.com/736x/4f/64/1b/4f641bb87608b6c94077da56b2a97508.jpg" alt=" AI-powered photo storage" style={{ width: '250px', height: '290px' }}/>
        </div>
      </section>

      <section className="lifoura-highlight">
        <h2>Why Lifoura?</h2>
        <ul>
          <li>🧠 AI-powered smart tagging and face recognition</li>
          <li>🔒 End-to-end encryption and secure vault access</li>
          <li>👨‍👩‍👧‍👦 Shareable albums for family and generations</li>
          <li>🌍 Access memories from anywhere in the world</li>
        </ul>
      </section>

      <section className="lifoura-section">
        <h2>Who is Lifoura For?</h2>
        <div className="lifoura-grid">
          <div>
            <h3>👶 New Parents</h3>
            <p>Capture every giggle, step, and sleepy smile.</p>
          </div>
          <div>
            <h3>👵 Grandparents</h3>
            <p>Record stories, advice, and precious wisdom forever.</p>
          </div>
          <div>
            <h3>💑 Couples</h3>
            <p>Build a shared timeline of your journey together.</p>
          </div>
          <div>
            <h3>📸 Memory Keepers</h3>
            <p>If you value nostalgia and legacy, Lifoura is for you.</p>
          </div>
        </div>
      </section>

      <section className="lifoura-section">
        <h2>How It Works</h2>
        <div className="lifoura-section-content">
          <p>
  <strong>Lifoura is simple:</strong> upload photos, videos, or journal entries, tag loved ones, and watch your timeline come alive.
  One place, one story—forever.<br /><br />
  Whether it's your baby's first laugh, your grandparents' anniversary, or a quiet journal entry on a rainy day—Lifoura captures it all in a secure, organized space.
  Each memory is beautifully arranged in a chronological timeline, enriched with smart tags and emotional context.
  Add captions, voice notes, or even handwritten letters. This isn’t just media storage—it’s your living, breathing life story preserved forever.
</p>

          <img
            src="https://i.pinimg.com/736x/23/26/0b/23260bbc6ca44b1d15c18f6a76021434.jpg"
            alt=" emotional storytelling platform"
          />
        </div>
      </section>

      <section className="lifoura-section">
        <h2>Visualize Your Life</h2>
        <div className="lifoura-section-content">
          <img
            src="https://i.pinimg.com/736x/fc/49/75/fc4975b326629f98ab61deadfccef41f.jpg"
            alt="encrypted memory storage"style={{ width: '250px', height: '290px' }}
          />
          <p>
          Browse a beautiful, chronological view of your life with media organized by <strong>dates</strong>,
      <strong> people</strong>, and <strong>events</strong>. <br></br><br></br>Relive moments anytime you wish.Your entire journey, visualized—birthdays, graduations, family vacations, and spontaneous snapshots,
      all lined up in a timeless scroll.Jump to your childhood with a click, revisit anniversaries with your partner, or watch your kids grow—year by year.
      Lifoura makes it feel like time travel for the heart.
          </p>
        </div>
      </section>

      <section className="lifoura-highlight">
        <h2>Timeline of Features</h2>
        <ul>
          <li>📆 Timeline view of your life’s events</li>
          <li>🎞️ Auto-organized by date, place, and people</li>
          <li>🗂️ Journal entries, photos, and videos stored forever</li>
          <li>🎁 Share memories with loved ones on special occasions</li>
        </ul>
      </section>

      <section className="lifoura-section">
        <h2>Real Voices</h2>
        <div className="lifoura-grid">
          <div>
            <p>"Lifoura helped us create a digital family tree filled with memories. My grandchildren love it!"</p>
            <strong>- Nisha P., Grandmother</strong>
          </div>
          <div>
            <p>"We’ve documented every month of our baby’s life. This website is pure gold."</p>
            <strong>- Rohan & Diya, New Parents</strong>
          </div>
          <div>
            <p>"As a traveler, Lifoura lets me keep my stories in one place, beautifully."</p>
            <strong>- Ankit, Travel Blogger</strong>
          </div>
          <div>
            <p>"My father left us videos of wisdom. Now they’re safe with Lifoura forever."</p>
            <strong>- Meera S., Daughter</strong>
          </div>
        </div>
      </section>

      <section className="lifoura-cta">
        <h2>Start Preserving Today</h2>
        <p>Don't let your story fade. Make it eternal with Lifoura.</p><br></br>
        <a href="/signin" className="lifoura-button">Create Your Vault</a>
      </section>

      <footer className="lifoura-footer">
        <p>&copy; {new Date().getFullYear()} Lifoura. All Rights Reserved. | <a href="mailto:support@lifoura.com" style={{ color: '#4a148c' }}>support@lifoura.com</a></p>
      </footer>
    </div>
    </div>
  );
};

export default LifouraBlog;
